import { useState, useEffect, useRef } from "react";
import Menu from "../components/Menu";
import ImageZoom from "../components/ImageZoom";
import { motion, AnimatePresence } from "framer-motion";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function Home() {
  const [showText, setShowText] = useState(false);
  const graySectionRef = useRef(null);
  const [photo, setPhoto] = useState([]);
  const API_BASE = "";
  const [ipAddress, setIPAddress] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIPAddress(data.ip);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    fetch("save_ip.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ip: ipAddress }),
    });
  }, [ipAddress]);

  useEffect(() => {
    const fetchPhotoHome = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/photohome`);
        if (!res.ok) throw new Error("Błąd pobierania danych z API");
        const data = await res.json();
        console.log("data: ", data[0].filename);
        setPhoto(`${API_BASE}/files/${data[0].filename}`);
      } catch (err) {
        console.error("Błąd:", err);
      } finally {
        console.log("ok");
      }
    };

    fetchPhotoHome();
  }, []);

  useEffect(() => {
    const textTimer = setTimeout(() => setShowText(true), 900);
    const imageTimer = setTimeout(() => 1600);
    return () => {
      clearTimeout(textTimer);
      clearTimeout(imageTimer);
    };
  }, []);

  useEffect(() => {
    const textObserver = new IntersectionObserver(
      ([entry]) => {
        setShowText(entry.isIntersecting);
      },
      { threshold: 0.4 },
    );
    if (graySectionRef.current) textObserver.observe(graySectionRef.current);
    return () => {
      textObserver.disconnect();
    };
  }, []);

  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <>
      <Helmet>
        <title>Fotografia wnętrz i nieruchomości | Tomasz Fotograf</title>
        <meta
          name="description"
          content="Profesjonalna fotografia wnętrz, nieruchomości, apartamentów i hoteli. Zdjęcia zwiększające sprzedaż ofert."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            name: "Tomasz Fotograf - fotografia nieruchomości",
            url: "https://tomaszfotograf.pl",
            image: "https://tomaszfotograf.pl/files/zxd.jpg",
            description:
              "Profesjonalna fotografia wnętrz i nieruchomości w Warszawie i okolicach.",
            areaServed: {
              "@type": "AdministrativeArea",
              name: "Warszawa i okolice",
            },
            address: {
              "@type": "PostalAddress",
              addressCountry: "PL",
            },
          })}
        </script>
      </Helmet>
      <Menu />
      <div className="fullpage">
        <section className="section section-dark section-home">
          <motion.div
            className="fade-in-text"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={textVariants}
          >
            <Row>
              <Col sm={12} md={4}>
                <h1 style={{ height: "auto", fontSize: "2rem", fontWeight: 300, color: "#fff" }}>
                  Profesjonalne zdjęcia nieruchomości - Piaseczno Warszawa
                </h1>
              </Col>
              <Col sm={12} md={8}>
                <ImageZoom src={photo} alt="title" />
              </Col>
            </Row>
          </motion.div>
        </section>
        <section className="section section-gray" ref={graySectionRef}>
          <AnimatePresence>
            {showText && (
              <motion.div
                className="fade-in-text"
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={textVariants}
              >
                <Row>
                  <Col className="d-flex" md={4}>
                    <p className="h1a">
                      FILMOWE PODEJŚCIE DO PREZENTACJI WNĘTRZ
                    </p>
                  </Col>
                  <Col md={8}>
                    <p className="h4a">
                      Specjalizuję się w profesjonalnej fotografii nieruchomości
                      na terenie Warszawy i okolic.
                    </p>
                    <p className="h4a">
                      Łączę doświadczenie zdobyte w branży filmowej i reklamowej
                      z techniczną precyzją oraz umiejętnością budowania
                      nastroju światłem. Dzięki temu każde wnętrze prezentuję
                      tak, jak kadr z dobrze wyreżyserowanego filmu.
                    </p>
                    <p className="h4a">
                      Pracuję dla agentów nieruchomości, właścicieli mieszkań,
                      deweloperów, projektantów wnętrz, architektów, producentów
                      mebli, hoteli, pensjonatów i restauracji.{" "}
                    </p>
                    <p className="h4a">
                      Tworzę zdjęcia, filmy oraz ujęcia dronem, które zwiększają
                      atrakcyjność ogłoszeń i szybciej przyciągają
                      klientów.{" "}
                    </p>
                    <p className="h4a">
                      ✔ Zdjęcia dostarczam w ciągu 24 godzin.{" "}
                    </p>
                    <p className="h4a">
                      ✔ Dojazd do 30 km od centrum Warszawy — w cenie.{" "}
                    </p>
                    <p className="h4a">
                      ✔ Dodatkowo oferuję staging wnętrz: zwykły, premium oraz
                      wirtualny.
                    </p>
                  </Col>
                </Row>
              </motion.div>
            )}
          </AnimatePresence>
        </section>
        <section className="section section-dark" style={{ flexDirection: "column", minHeight: "auto", paddingBottom: "4%" }}>
          <AnimatePresence>
            <motion.div
              style={{ width: "100%" }}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            >
              <Row style={{ margin: 0 }}>
                {[
                  {
                    to: "/zdjecia-z-drona",
                    title: "Zdjęcia z drona",
                    text: "Oferuję profesjonalne zdjęcia z drona, które pozwalają pokazać nieruchomości, inwestycje i przestrzenie z zupełnie nowej perspektywy. Moje zdjęcia z drona są szczególnie skuteczne w prezentacji działek, domów oraz większych obiektów komercyjnych. Dzięki nim można uchwycić nie tylko sam budynek, ale także jego otoczenie. Realizując zdjęcia z drona na terenie Warszawy oraz Piaseczna, dbam o odpowiednie światło, kompozycję oraz czytelność ujęć.",
                  },
                  {
                    to: "/fotografia-restauracji-warszawa",
                    title: "Fotografia restauracji",
                    text: "Specjalizuję się również w usługach takich jak fotografia restauracji, które pomagają lokalom gastronomicznym przyciągać klientów i budować silną markę. Moja fotografia restauracji obejmuje zarówno zdjęcia dań, jak i wnętrz oraz atmosfery miejsca. Wykonywana przeze mnie fotografia restauracji działa na emocje – pokazuję świeżość potraw, klimat lokalu i detale, które mają znaczenie dla odbiorcy.",
                  },
                  {
                    to: "/fotograf-wnetrz",
                    title: "Fotograf wnętrz",
                    text: "Jako fotograf wnętrz oferuję profesjonalne usługi dla klientów indywidualnych, architektów i firm. Moja fotografia wnętrz skupia się na pokazaniu przestrzeni w sposób estetyczny, funkcjonalny i atrakcyjny wizualnie. Tworzę zdjęcia wnętrz, które podkreślają układ pomieszczeń, światło oraz detale aranżacji. Działam w Warszawie i Piasecznie.",
                  },
                  {
                    to: "/fotografia-nieruchomosci",
                    title: "Fotografia nieruchomości",
                    text: "Moja główna usługa to fotografia nieruchomości, która obejmuje kompleksowe przygotowanie materiałów do sprzedaży i wynajmu. Tworzę zdjęcia nieruchomości, które przyciągają uwagę i zwiększają skuteczność ogłoszeń. Wykonuję zdjęcia domów, zdjęcia mieszkań oraz przestrzeni komercyjnych. Oferuję profesjonalne zdjęcia nieruchomości gotowe do publikacji.",
                  },
                ].map(({ to, title, text }) => (
                  <Col key={to} sm={12} md={6} style={{ padding: "2rem 1.5rem" }}>
                    <div style={{ borderTop: "1px solid rgba(255,255,255,0.15)", paddingTop: "1.5rem" }}>
                      <h2 style={{ color: "#fff", fontWeight: 300, fontSize: "1.8rem", marginBottom: "1rem" }}>
                        <Link to={to} style={{ color: "#fff", textDecoration: "none" }}>
                          {title}
                        </Link>
                      </h2>
                      <p className="h4a" style={{ fontSize: "1rem", lineHeight: "1.7rem" }}>{text}</p>
                      <Link to={to} style={{ color: "#4db6ac", fontSize: "0.95rem", textDecoration: "none" }}>
                        Dowiedz się więcej →
                      </Link>
                    </div>
                  </Col>
                ))}
              </Row>
            </motion.div>
          </AnimatePresence>
        </section>
      </div>
    </>
  );
}
